import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addOnlinePayForOther, postGatewayPaymentOneItem } from 'services/easyPay'

export default function useGetMoneyPoolCashin(data: any) {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: any) => {
            // return addOnlinePayForOther(payload)
            return postGatewayPaymentOneItem(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'pay-for-other',
                    data: data ? data : [],
                    //@ts-ignore
                    // pk: result.cashins[0].transaction.pk,
                    //@ts-ignore
                    // gateway: 0,
                })
            )
            //@ts-ignore
            window.location.replace(result?.payment_link)
            // if (result?.cashins[0].transaction.pay_url) {
            //     // window.location.replace(result?.cashins[0].transaction.pay_url)
            // } else {
            //     toast.success('پرداخت با موفقیت انجام شد')
            //     navigate('/gateway-callback')
            // }
            toast.success('در حال انتقال به صفحه کارت به کارت')

        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
